import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-grid-icon',
  templateUrl: './layout-layout-grid.component.html'
})
export class LayoutLayoutGridComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
